
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.792 15.333H6.76c-3.648 0-5.207-1.559-5.207-5.207V6.094C1.553 2.446 3.112.887 6.76.887h4.032c3.648 0 5.207 1.559 5.207 5.207v4.032c0 3.648-1.559 5.207-5.207 5.207zM6.76 1.895c-3.097 0-4.199 1.102-4.199 4.2v4.03c0 3.098 1.102 4.2 4.2 4.2h4.03c3.098 0 4.2-1.102 4.2-4.2v-4.03c0-3.098-1.101-4.2-4.2-4.2h-4.03z","fill":"#4FAEAF"}}),_c('path',{attrs:{"d":"M8.776 10.3a.498.498 0 01-.356-.148L6.404 8.137a.507.507 0 010-.713.507.507 0 01.713 0l1.66 1.66 1.659-1.66a.507.507 0 01.712 0 .507.507 0 010 .713l-2.016 2.015c-.1.101-.228.148-.356.148z","fill":"#4FAEAF"}}),_c('path',{attrs:{"d":"M8.776 10.3a.508.508 0 01-.504-.504V4.421c0-.275.229-.504.504-.504.276 0 .504.229.504.504v5.375a.503.503 0 01-.504.504zM8.776 12.296c-1.418 0-2.842-.229-4.193-.679a.506.506 0 01-.315-.638.498.498 0 01.638-.316c2.5.833 5.248.833 7.747 0a.506.506 0 01.638.316.506.506 0 01-.315.638 13.179 13.179 0 01-4.2.679z","fill":"#4FAEAF"}})])
          )
        }
      }
    